import { apiBase } from './api'

export enum VS {
	brwsr = 1,
	tab = 2,
	all = 3,
}

function getKeyName(key: string) {
	return (apiBase.state.userId == null ? '0' : apiBase.state.userId) + key;
}
export function getVal(key: string, vs = VS.brwsr) {
	key = getKeyName(key);
	function get(storage: Storage): string {
		const v = storage.getItem(key);
		if (v == 'null')
			return null;
		return v;
	}
	let r: string = null;
	if ((vs & VS.tab))
		r = get(window.sessionStorage);
	if (r == null && (vs & VS.brwsr))
		r = get(window.localStorage);
	return r;
}
export function setVal(key: string, val: any, vs = VS.brwsr) {
	key = getKeyName(key);
	function set(storage: Storage) {
		// eslint-disable-next-line sonarjs/no-redundant-boolean
		if (val == null || val == false)
			storage.removeItem(key);
		else
			storage.setItem(key, val);
	}
	if ((vs & VS.brwsr))
		set(window.localStorage);
	if ((vs & VS.tab))
		set(window.sessionStorage);
}

export function getBool(key: string, vs = VS.brwsr) {
	return getVal(key, vs) != null;
}
export function getFloat(key: string, vs = VS.brwsr) {
	const v = getVal(key, vs);
	if (v) {
		const f = Number.parseFloat(v);
		if (!isNaN(f))
			return f;
	}
	return null;
}
export function getInt(key: string, vs = VS.brwsr) {
	const v = getVal(key, vs);
	if (v) {
		const i = Number.parseInt(v);
		if (!isNaN(i))
			return i;
	}
	return null;
}

export function setBool(key: string, val: boolean, vs = VS.brwsr) {
	setVal(key, val, vs);
}
export function setJson<T>(key: string, v: T, vs = VS.brwsr) {
	setVal(key, JSON.stringify(v), vs);
	return v;
}
export function getJson<T>(key: string, vs = VS.brwsr): T {
	const v = getVal(key, vs);
	if (!v)
		return null;
	return JSON.parse(v) as T;
}
export function objectFromJson<T>(json: string) {
	try {
		if (!json)
			return null;
		return JSON.parse(json) as T;
	} catch {
		return null;
	}
}
export function equalIC(s1: string, s2: string) {
	if (s1 == null && s2 == null)
		return true;
	return s1?.toLowerCase() == s2?.toLowerCase();
}

export function isSet(e: number, flg: number) {
	if (e == null)
		return false;
	return (e & flg) == flg;
}

export function setFlag(e: number, flg: number, value: boolean) {
	if (value) {
		if (!isSet(e, flg))
			e |= flg;
	} else if (isSet(e, flg)) {
		e ^= flg;
	}
	return e;
}
export function takemax(v: string, max: number = 50) {
	if (!v)
		return v;
	if (v.length > max)
		return v.substring(0, max) + '..';
	return v;
}
export function pad(v: number, n: number = 2) {
	if (v < 10)
		return `0${v}`;
	return `${v}`;
}

export function excludeEnumVals<T>(v: T, ...vals: T[]) {
	const t = Object.assign({}, v) as any;
	for (let c of vals) {
		const n = t[c];
		delete t[`${c}`];
		delete t[n];
	}
	return t as T;
}

export interface HashTable<T> {
	[key: string | number]: T;
}
